// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mIWi","comment":"styles_comment__6RNfZ"};